import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import Lang from '/@/modules/core/app/services/Lang';
import BillingPlanMappingService from '/@/modules/billing/services/BillingPlanMappingService';

export class BillingPlanSelectConfig extends FormSelectConfig {
  constructor(config = {}) {
    super({
      placeholder: Lang.t('billing.select-plan'),
      trackBy: 'planId',
      label: 'planName',
      ...config
    });
  }

  /**
   * @return {Promise<BillingPlan[]>}
   */
  async getOptions(params = {}) {
    return BillingPlanMappingService.getEntities();
  }
}
